import { Outlet } from 'react-router-dom';

export const GraphsOutlet = () => <Outlet />;
